import { FunctionComponent, ReactNode } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  container: {
    '@media (min-width: 1200px)': {
      padding: '0 50px 20px',
    },
  },
}), { name: 'MainPageContainer' });

export type MainPageContainerProps = {
  children: ReactNode;
  className?: string;
};

const MainPageContainer: FunctionComponent<MainPageContainerProps> = ({
  className,
  children,
}): JSX.Element => {
  const classes = useStyles();
  return <div className={clsx([classes.container, className])}>{children}</div>;
};

export default MainPageContainer;
